module.exports = __webpack_public_path__ + "media/images/pc/specials/common/special_c_15-a6b78a9d730100c31402830a20ca82ae.jpg";